import styled from 'styled-components';

export const CircleNewDataAlertPanel = styled.div`
  display: flex;
  position: absolute;
  font-weight: 900;
  padding: 1px;
  right: -5px;
  bottom: 2px;
  background-color: red;
  color: #ffffff;
  width: 15px;
  height: 15px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;
